export type ArchiveDataStatus = 'Queued' | 'Running' | 'Completed' | 'Failed';

export interface ArchiveDataRun {
  id: string;
  status: ArchiveDataStatus;
  createdBy: string;
  createdOn: string;
  startedOn: string | null;
  completedOn: string | null;
  queueId: string | null;
  applicationsArchived: number;
  inspectionsArchived: number;
  registrationsArchived: number;
  contractorRegistrationsArchived: number;
  totalApplications: number | null;
  errorMessage: string | null;
}

export interface ArchiveDataSummary {
  clientId: string;
  mode: number;
  eligibleApplications: number;
  eligibleInspections: number;
  eligibleRegistrations: number;
  eligibleContractorRegistrations: number;
  executionAvailable: boolean;
  executionUnavailableReason: string | null;
  executionNotice?: string;
  runs: ArchiveDataRun[];
}

export const ARCHIVE_CONFIRMATION =
  'I understand this will permanently archive all applications in this jurisdiction.';
